const ETA_FIELDS = [
  {
    milestone: 'Document verification',
    field: 'expectedVerificationDate',
  },
  {
    milestone: 'Claim sent to insurer',
    field: 'expectedDateSentToInsurer',
  },
  {
    milestone: 'Claim settlement',
    field: 'expectedClaimSettlementDate',
  },
];

export const getEtaDisplay = (statusItem) => {
  if (!statusItem) return null;

  const match = ETA_FIELDS.find((item) => statusItem[item.field]);
  if (!match) return null;

  return {
    label: `${match.milestone} expected by`,
    value: statusItem[match.field],
  };
};
